import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import Toast, { PluginOptions,POSITION  } from "vue-toastification";

//Toast CSS
import "vue-toastification/dist/index.css";

const options: PluginOptions = {
    position: POSITION.TOP_CENTER,
    timeout: 2500
};

// importing AOS
import AOS from 'aos'
AOS.init({ once: 'true'});
import 'aos/dist/aos.css'

createApp(App).use(i18n).use(Toast, options).use(store).use(router).use(AOS.init()).mount('#app')
